// Dependencies
require("section/quote");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/quote/index.js
 ** module id = 182
 ** module chunks = 0 1
 **/